import cookies from 'js-cookie';
import * as v from 'valibot';
import { isLikelyABotBasedOnScore } from '../headers/getCFBotHeaders';
import {
  BOT_SCORE_COOKIE_NAME,
  IS_BOT_USER_AGENT_COOKIE_NAME,
  IS_VERIFIED_BOT_COOKIE_NAME,
} from './constants';
import { botFlagSchema, botScoreSchema } from './schema';

export function getBotCookies() {
  const botScore = cookies.get(BOT_SCORE_COOKIE_NAME) ?? '';
  const isVerifiedBot = cookies.get(IS_VERIFIED_BOT_COOKIE_NAME) ?? '';
  const isBotUserAgent = cookies.get(IS_BOT_USER_AGENT_COOKIE_NAME) ?? '';

  const validatedBotScore = v.safeParse(botScoreSchema, botScore);
  const validatedIsVerifiedBot = v.safeParse(botFlagSchema, isVerifiedBot);
  const validatedIsBotUserAgent = v.safeParse(botFlagSchema, isBotUserAgent);

  const score = validatedBotScore.success ? validatedBotScore.output : 0;

  return {
    botScore: score,
    isBot: isLikelyABotBasedOnScore(score),
    isBotUserAgent: validatedIsBotUserAgent.success ? validatedIsBotUserAgent.output : false,
    isVerifiedBot: validatedIsVerifiedBot.success ? validatedIsVerifiedBot.output : false,
  };
}
